var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCmsConnectionIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "-29 0 511 512",
    width: "512pt",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 179.8871290442,
    x2: 272.9247972566,
    y1: 56.700510638,
    y2: 347.7137054866
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fffcf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#faf8f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4041,
    stopColor: "#eceef2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6353,
    stopColor: "#d5dcea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#b5c4df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a1b5d8"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 256.237304596,
    x2: 603.5058710678,
    y1: 87.0976625228,
    y2: 157.4168770518
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1b5d8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2632,
    stopColor: "#8ea0ba",
    stopOpacity: 0.262745
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5306,
    stopColor: "#808fa3",
    stopOpacity: 0.529412
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7822,
    stopColor: "#778595",
    stopOpacity: 0.780392
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#748290"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 146.233555368,
    x2: -112.4458216656,
    y1: 121.9384743562,
    y2: 224.1729716184
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1b5d8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3552,
    stopColor: "#8e9fb9",
    stopOpacity: 0.356863
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7668,
    stopColor: "#7b8a9b",
    stopOpacity: 0.768627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#748290"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#445ea0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3216,
    stopColor: "#415a9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6926,
    stopColor: "#364d8d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2a3d7c"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 121.7952829064,
    x2: 121.7952829064,
    xlinkHref: "#d",
    y1: 274.3092378672,
    y2: 432.5107803542
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    x1: 331.4117870936,
    x2: 331.4117870936,
    xlinkHref: "#d",
    y1: 274.3092378672,
    y2: 432.5107803542
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientUnits: "userSpaceOnUse",
    x1: 226.603535,
    x2: 226.603535,
    xlinkHref: "#d",
    y1: 278.7135440734,
    y2: 439.5765841746
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4974"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3262,
    stopColor: "#fe4672"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5324,
    stopColor: "#fb3e6c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7054,
    stopColor: "#f52f60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8591,
    stopColor: "#ee1a51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e4003d"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientUnits: "userSpaceOnUse",
    x1: 56.927666014,
    x2: 94.6114845592,
    xlinkHref: "#h",
    y1: 453.4065132544,
    y2: 549.9714614138
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    gradientUnits: "userSpaceOnUse",
    x1: 96.0413706638,
    x2: 96.0413706638,
    xlinkHref: "#h",
    y1: 409.1546354164,
    y2: 510.5060828874
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd00d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2378,
    stopColor: "#ffcb0e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5353,
    stopColor: "#fb1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8632,
    stopColor: "#ffa215"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9517"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    gradientUnits: "userSpaceOnUse",
    x1: 222.5796148396,
    x2: 260.263533777,
    xlinkHref: "#k",
    y1: 453.4065132544,
    y2: 549.9714614138
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    gradientUnits: "userSpaceOnUse",
    x1: 261.6933194894,
    x2: 261.6933194894,
    xlinkHref: "#k",
    y1: 409.1546354164,
    y2: 510.5060828874
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "n"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00e7b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2459,
    stopColor: "#05e5b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5301,
    stopColor: "#13ddac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8322,
    stopColor: "#2ad1a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3ac9a0"
  }))), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    gradientUnits: "userSpaceOnUse",
    x1: 388.2316640574,
    x2: 425.9154826026,
    xlinkHref: "#n",
    y1: 453.4065132544,
    y2: 549.9714614138
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    gradientUnits: "userSpaceOnUse",
    x1: 427.3453687072,
    x2: 427.3453687072,
    xlinkHref: "#n",
    y1: 409.1546354164,
    y2: 510.5060828874
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    gradientUnits: "userSpaceOnUse",
    x1: 226.603535,
    x2: 226.603535,
    y1: 234.0816817584,
    y2: 377.2219848326
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1b5d8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6299,
    stopColor: "#8393a8",
    stopOpacity: 0.631373
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#748290"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m350.257812 90.925781c-5.039062-.066406-9.996093.230469-14.847656.859375-4.390625.570313-8.199218-2.886718-8.195312-7.3125 0-.03125 0-.058594 0-.089844 0-46.601562-37.78125-84.382812-84.382813-84.382812-36.675781 0-67.871093 23.402344-79.5 56.082031-1.203125 3.375-4.625 5.441407-8.148437 4.789063-3.726563-.691406-7.570313-1.058594-11.496094-1.058594-34.867188 0-63.132812 28.265625-63.132812 63.132812v.226563c.015624 3.675781-2.632813 6.859375-6.277344 7.316406-41.535156 5.210938-73.679688 40.597657-73.777344 83.523438-.105469 46.515625 38.929688 84.574219 85.449219 84.574219h262.921875c57.550781 0 104.164062-46.820313 103.832031-104.445313-.320313-56.296875-46.152344-102.472656-102.445313-103.214844zm0 0",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m327.214844 84.382812c0 3.007813-.164063 5.972657-.464844 8.902344-38.234375 8.289063-68.613281 37.636719-78.390625 75.296875-1.828125.117188-3.667969.183594-5.527344.183594-46.605469 0-84.382812-37.777344-84.382812-84.382813 0-46.605468 37.777343-84.382812 84.382812-84.382812s84.382813 37.777344 84.382813 84.382812zm0 0",
    fill: "url(#b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m206.816406 122.9375c0 28.019531-18.261718 51.777344-43.519531 60.03125-12.410156-31.144531-42.84375-53.148438-78.414063-53.148438-1.320312 0-2.636718.03125-3.9375.097657-.261718-2.296875-.390624-4.621094-.390624-6.980469 0-34.855469 28.269531-63.125 63.136718-63.125 34.855469.003906 63.125 28.269531 63.125 63.125zm0 0",
    fill: "url(#c)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m191.863281 276.910156v42.089844c0 21.679688-17.640625 39.320312-39.320312 39.320312h-61.496094c-11.941406 0-21.65625 9.714844-21.65625 21.65625v43.703126c0 4.875-3.957031 8.832031-8.832031 8.832031s-8.832032-3.957031-8.832032-8.832031v-43.703126c0-21.679687 17.640626-39.320312 39.320313-39.320312h61.496094c11.941406 0 21.65625-9.714844 21.65625-21.65625v-44.691406c5.640625 1.035156 11.539062 1.910156 17.664062 2.601562zm0 0",
    fill: "url(#e)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m401.480469 379.976562v43.703126c0 4.875-3.957031 8.832031-8.832031 8.832031s-8.832032-3.957031-8.832032-8.832031v-43.703126c0-11.941406-9.714844-21.65625-21.65625-21.65625h-61.496094c-21.679687 0-39.320312-17.640624-39.320312-39.320312v-42.089844c6.125-.691406 12.023438-1.566406 17.664062-2.601562v44.691406c0 11.941406 9.714844 21.65625 21.65625 21.65625h61.496094c21.679688 0 39.320313 17.640625 39.320313 39.320312zm0 0",
    fill: "url(#f)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m235.4375 278.714844v152.03125c0 4.875-3.957031 8.832031-8.835938 8.832031-4.875 0-8.832031-3.957031-8.832031-8.832031v-152.03125c2.921875.082031 5.867188.117187 8.832031.117187 2.96875 0 5.914063-.035156 8.835938-.117187zm0 0",
    fill: "url(#g)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m100.90625 512h-79.910156c-4.597656 0-8.328125-3.730469-8.328125-8.328125v-79.910156c0-4.597657 3.730469-8.328125 8.328125-8.328125h79.910156c4.597656 0 8.328125 3.730468 8.328125 8.328125v79.910156c0 4.597656-3.730469 8.328125-8.328125 8.328125zm0 0",
    fill: "url(#i)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m100.90625 415.433594h-18.058594c4.601563 0 8.328125 3.730468 8.328125 8.328125v79.910156c0 4.597656-3.726562 8.328125-8.328125 8.328125h18.058594c4.597656 0 8.328125-3.730469 8.328125-8.328125v-79.910156c0-4.597657-3.730469-8.328125-8.328125-8.328125zm0 0",
    fill: "url(#j)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m266.558594 512h-79.910156c-4.597657 0-8.328126-3.730469-8.328126-8.328125v-79.910156c0-4.597657 3.730469-8.328125 8.328126-8.328125h79.910156c4.597656 0 8.328125 3.730468 8.328125 8.328125v79.910156c0 4.597656-3.730469 8.328125-8.328125 8.328125zm0 0",
    fill: "url(#l)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m266.558594 415.433594h-18.058594c4.601562 0 8.328125 3.730468 8.328125 8.328125v79.910156c0 4.597656-3.726563 8.328125-8.328125 8.328125h18.058594c4.597656 0 8.328125-3.730469 8.328125-8.328125v-79.910156c0-4.597657-3.730469-8.328125-8.328125-8.328125zm0 0",
    fill: "url(#m)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m432.210938 512h-79.910157c-4.597656 0-8.328125-3.730469-8.328125-8.328125v-79.910156c0-4.597657 3.730469-8.328125 8.328125-8.328125h79.910157c4.597656 0 8.328124 3.730468 8.328124 8.328125v79.910156c0 4.597656-3.730468 8.328125-8.328124 8.328125zm0 0",
    fill: "url(#o)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m432.210938 415.433594h-18.058594c4.601562 0 8.328125 3.730468 8.328125 8.328125v79.910156c0 4.597656-3.726563 8.328125-8.328125 8.328125h18.058594c4.597656 0 8.328124-3.730469 8.328124-8.328125v-79.910156c0-4.597657-3.730468-8.328125-8.328124-8.328125zm0 0",
    fill: "url(#p)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m342.421875 236.957031c0-23.125-51.855469-41.871093-115.820313-41.871093-63.960937 0-115.816406 18.746093-115.816406 41.871093s51.855469 41.875 115.816406 41.875c63.964844 0 115.820313-18.75 115.820313-41.875zm0 0",
    fill: "url(#q)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCmsConnectionIcon);
export default __webpack_public_path__ + "static/media/cms-connection-icon.75fafc3e45d67a1a0ccc6d5a7f7df164.svg";
export { ForwardRef as ReactComponent };